import { ActionLogsDataType, NormalizedActionLogsDataType } from '../types/actionLogsTypes';

const normalizeActionLog = (row: ActionLogsDataType): NormalizedActionLogsDataType => ({
  ...row,
  error_type: row.error_type ?? '',
  error_message: row.error_message ?? '',
});

export const normalizeActionLogs = (rows: ActionLogsDataType[]): NormalizedActionLogsDataType[] =>
  rows.map(normalizeActionLog);
